import React from "react";
import { CreateContainer } from "../../Containers/ContainerCreate";
import { getChimsList } from "../../api/getChim";
import Spinner from "react-bootstrap/Spinner";

class ChimneyListContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const chimneys = (data && data.data) || {};
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    return render({ chimneys, loading, failure });
  };
}

export default CreateContainer(getChimsList, ChimneyListContainer);
